@use "../../../styles/variables.scss" as *;
@use "../../../styles/typography.scss" as *;

.button {
  border-radius: 9999px;
  padding-left: 24px;
  padding-right: 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  &:focus {
    outline: 2px solid $purple;
    outline-offset: 2px;
  }
}

.sizeSmall {
  @include text-style("text-lg-bold");
  padding-top: 8px;
  padding-bottom: 8px;

  .loadingSpinner {
    width: 24px;
    height: 24px;

    &:after {
      height: 24px;
      width: 24px;
      border-width: 3px;
    }
  }
}

.sizeMedium {
  @include text-style("p-text-base");
  padding-top: 20px;
  padding-bottom: 20px;

  .loadingSpinner {
    width: 24px;
    height: 24px;

    &:after {
      height: 24px;
      width: 24px;
      border-width: 3px;
    }
  }

  &.textBrand {
    font-family: $font-family-brand;
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
  }
}

.variantPrimary {
  background: $almost-black;
  color: $light-volt;

  .loadingSpinner:after {
    border-color: $light-volt $light-volt $light-volt transparent;
  }

  &:hover {
    background: $light-volt;
    color: $almost-black;

    .loadingSpinner:after {
      border-color: $almost-black $almost-black $almost-black transparent;
    }
  }

  &:active {
    background:
      linear-gradient(0deg, $neutral-grey-100 0%, $neutral-grey-100 100%),
      $light-volt;
  }

  &.toneDestructive {
    background: $secondary-red-1000;
    color: $white;

    .loadingSpinner:after {
      border-color: $white $white $white transparent;
    }

    &:hover {
      background: $destructive-hover-color;
      color: $white;

      .loadingSpinner:after {
        border-color: $white $white $white transparent;
      }
    }

    &:active {
      background: $destructive-press-color;
    }
  }

  &:disabled,
  &:disabled:hover,
  &:disabled:active {
    background: $neutral-grey-100;
    color: $almost-black-400;

    svg {
      color: $almost-black-400;
    }

    .loadingSpinner:after {
      border-color: $almost-black-400 $almost-black-400 $almost-black-400
        transparent;
    }
  }
}

.variantSecondary {
  border: 1px solid $almost-black;

  &:hover {
    background: $light-volt;
  }

  &:active {
    background:
      linear-gradient(0deg, $neutral-grey-100 0%, $neutral-grey-100 100%),
      $light-volt;
  }

  &:disabled,
  &:disabled:hover,
  &:disabled:active {
    border-color: $almost-black-300;
    color: $almost-black-400;
    background: unset;

    svg {
      color: $almost-black-400;
    }
  }
}

.variantTertiary {
  text-decoration: underline;

  &.sizeMedium {
    text-decoration: none;
  }

  &:hover {
    background: $fill-hover;
  }

  &:active {
    background: $fill-press;
  }

  &:disabled {
    color: $almost-black-400;
    background: unset;

    svg {
      color: $almost-black-400;
    }
  }
}

.fullWidth {
  width: 100%;
}
